export default {
	data() {
		return {
			pageStart: 0,
			hasMore: false,
			queryOptions: {},
			tabData: [],
			emptyData: false
		};
	},
	methods: {
		PAGINATION_LOAD_MORE() {
			if (!this.hasMore) {
				console.log('uninstall.');
				this.PAGINATION_OBS_UNINSTALL();
				return;
			}
			this.pageStart++;
			this.PAGINATION_LOAD().then(more => {
				this.hasMore = more;
			});
		},
		PAGINATION_REFRESH(query) {
			this.pageStart = 0;
			this.hasMore = false;
			this.queryOptions = { ...query };
			this.PAGINATION_LOAD().then(more => {
				this.hasMore = more;
				if (more) {
					this.$nextTick(() => {
						this.PAGINATION_OBS_INSTALL();
					});
				}
				if (!this.tabData.length) {
					this.emptyData = true;
				} else {
					this.emptyData = false;
				}
			});
		},
		PAGINATION_DATA_UPDATE(result) {
			if (this.pageStart === 0) {
				this.tabData = result;
			} else {
				this.tabData = this.tabData.concat(result);
			}
		}
	}
};
